import React, { useCallback } from 'react'
import DropDown from '@commonComponents/formComponents/CustomDropDown'
import { useDropdownList } from '../hooks/useDropdownList'

const MUDropdown = (props) => {
    const {
        translate,
        countryCode,
        fieldName: { key, text, value, mdocumentName='' },
        fieldValue,
        setFieldValue
    } = props

    const valueList = useDropdownList(key, countryCode, {mdocumentName})

    const onDropDownChange = useCallback(
        (e, { value, name }) => {
            if (name == 'massUpdateDropdownValue') setFieldValue(value)
        }, []
    )


    return (
        <DropDown
            id={`${key}`}
            label={translate(`${text}`, { ns: ['default', `${text}`] })}
            name='massUpdateDropdownValue'
            className='field-bg dropdown100'
            labelClass='text-none'
            isLabel={true}
            clearable
            data={valueList}
            isDisabled={!value}
            value={fieldValue}
            onChange={onDropDownChange}
        />
    )
}

export default MUDropdown